var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from 'styled-components';
var Loading2 = function () {
    return (React.createElement(Load, null,
        React.createElement("img", { src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_pres/_v5/happy_loading_5.gif"), 
            // alt=""
            width: "60", height: "69" })));
};
var Load = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width : 100%;\n    height : 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin : auto;\n    padding : 10% 0 10% 0;\n"], ["\n    width : 100%;\n    height : 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin : auto;\n    padding : 10% 0 10% 0;\n"])));
export default Loading2;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/main/loading2.tsx
// module id = 23
// module chunks = 0